import React from 'react';

const ClaimStatusCard = ({ status, amount, icon, classNames }) => {
  console.log(amount);
  return (
    <div
      className={`rounded-xl ${classNames} font-lato shadow-[8px_8px_12px_0px_rgba(0,0,0,0.15)] p-6 flex items-center justify-between`}
    >
      <div>
        <div className="text-[#3A3541] text-[16px]">{status}</div>
        <div className="text-2xl font-bold text-[#3A3541]">{Number(amount).toLocaleString('en-US')}</div>
      </div>
      <div>
        {icon}
      </div>
    </div>
  );
};

export default ClaimStatusCard;
